import React, { useState } from 'react';
import { RequiredDialogInput, DialogInput, handleInputChange, RequiredDialogSelect, DialogCheckbox } from '../DialogInputs';
import { useSaveBusinessUnit } from '../../../../hooks/useBusinessUnits';
import CommonConfigDialog from './CommonConfigDialog';
import { useGetSites } from '../../../../hooks/useSites';
import { useTranslation } from 'react-i18next';
import { Card, Col, Form, Row } from 'react-bootstrap'

function BusinessUnitEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {

    const { t } = useTranslation();

    const [fieldErrors, setFieldErrors] = useState({});

    const { saveBusinessUnit } = useSaveBusinessUnit();
    const { sites } = useGetSites();

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }

    return (
        <CommonConfigDialog title={"Business Unit - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveBusinessUnit} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formBusinessUnitName" title="Name" placeholder="Business Unit Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <RequiredDialogSelect controlId="formBusinessUnitSite" title="Site" name="siteId" value={dialogData.siteId} error={fieldErrors.siteId} onChange={onChange}>
                <option value="" key={0} >{t('Application.Controls.DefaultSelect')}</option>
                {sites.map((site) => <option value={site.id} key={site.id}>{site.name}</option>)}
            </RequiredDialogSelect>
            <DialogInput controlId="formBusinessUnitDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formBusinessUnitADGroupName" title="AD Group Name" placeholder="AD Group Name" name="adGroupName" value={dialogData.adGroupName} error={fieldErrors.adGroupName} onChange={onChange} />
            <Card className="mb-2">
                <Card.Header>{t('BusinessUnit.Sections.Options')}</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group as={Row}>
                                <Form.Label column sm={9}>{t('BusinessUnit.Fields.UsesSubCategories')}</Form.Label>
                                <Col sm={3}>
                                    <DialogCheckbox controlId="formBusinessUnitUsesSubCategories" name="usesSubCategories" checked={dialogData.usesSubCategories} onChange={onChange}></DialogCheckbox>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Form.Group as={Row}>
                                <Form.Label column sm={9}>{t('BusinessUnit.Fields.ShowGradingActionsSection')}</Form.Label>
                                <Col sm={3}>
                                    <DialogCheckbox controlId="formBusinessUnitShowGradingActionsSection" name="showGradingActionsSection" checked={dialogData.showGradingActionsSection} onChange={onChange}></DialogCheckbox>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </CommonConfigDialog>
    );
}

export default BusinessUnitEditDialog;